<template>
    <line-graph
        :graph-data="graphData"
        :options="options"
        name="test-results"
    ></line-graph>
</template>

<script>
export default {
    name: "SeoTestResultsGraph",
    props: {
        records: {
            type: Array
        }
    },
    data(){
        return {
            graphData: {
                datasets: [],
                labels: [],
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            callback: function(value, index, values){
                                return value + 's';
                            }
                        }
                    }]
                }
            }
        }
    },
    mounted: function(){
        const records = this.records
        const labels = records.map(record => record.created_at_diff)
        
        this.graphData.labels = labels;
        this.graphData.datasets.push({
            label: 'LCP',
            data: records.map(record => record.largest_contentful_paint / 1000),
            fill: false,
            borderColor: 'rgb(75, 192, 192)',
            tension: 0.1
        });
        this.graphData.datasets.push({
            label: 'FCP',
            data: records.map(record => record.first_contentful_paint / 1000),
            fill: false,
            borderColor: 'rgb(255, 154, 0)',
            tension: 0.1
        });
        this.graphData.datasets.push({
            label: 'TTI',
            data: records.map(record => record.time_to_interactive / 1000),
            fill: false,
            borderColor: 'rgb(193, 67, 5)',
            tension: 0.1
        });
        this.graphData.datasets.push({
            label: 'Speed Index',
            data: records.map(record => record.speed_index / 1000),
            fill: false,
            borderColor: 'rgb(0, 179, 48)',
            tension: 0.1
        });
    }
}
</script>